import {useEffect} from 'react'
import {SectionEditModalHeader} from './SectionEditModalHeader'
import {SectionEditModalFormWrapper} from './SectionEditModalFormWrapper'
import { ID } from '../../../../../_dashboard/helpers'
type Props = {
  sectionId: ID // Ajouter cette ligne
  pageId: ID    // Ajouter cette ligne
  onClose: () => void
}
const SectionEditModal = ({ sectionId, pageId, onClose }: Props) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className={`modal fade ${sectionId ? 'show d-block' : 'd-none'}`} 
        id='kt_modal_add_section'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-dialog-scrollable mw-500px'>
        {/* begin::Modal content */}
          <div className='modal-content border-0 rounded-4 shadow-lg overflow-hidden'>
          <SectionEditModalHeader onClose={onClose} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y px-8 py-6'>
            <SectionEditModalFormWrapper pageId={pageId} sectionId={sectionId} onSuccess={onClose} // Fermer après soumission
        onClose={onClose} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show' style={{backgroundColor: 'rgba(15, 23, 42, 0.45)'}}></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {SectionEditModal}
